(() => {
  'use strict';
  const page = document.getElementById('trobart-local-page');
  const configNode = document.getElementById('tm-config');
  if (!page || !configNode || page.dataset.initialized) return;
  page.dataset.initialized = 'true';
  const config = JSON.parse(configNode.textContent);
  const text = config.text;
  const $ = s => page.querySelector(s);
  const root = (config.rootUrl || '/').replace(/\/$/, '');
  const urlFor = p => `${root}/products/${encodeURIComponent(p.handle)}`;
  const normalize = v => String(v || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().replace(/[’']/g, '').trim();
  const regionOf = p => p.tags.map(tag => config.regions[tag]).find(Boolean)?.name || '';
  const money = new Intl.NumberFormat(page.dataset.locale === 'ca' ? 'ca-ES' : 'es-ES', {style:'currency', currency:config.currency || 'EUR'});
  const collator = new Intl.Collator(page.dataset.locale, {sensitivity:'base', numeric:true});
  let products = [], visible = 24, loading = false, ready = false;
  const search = $('#tm-search'), area = $('#tm-area'), sort = $('#tm-sort');
  function node(tag, className, content) { const el = document.createElement(tag); if (className) el.className = className; if (content !== undefined) el.textContent = content; return el; }
  function row(p) {
    const article = node('article', 'tm-card');
    const imageLink = node('a','tm-card-art'); imageLink.href = urlFor(p);
    const image = node('img'); const imageURL = new URL(p.image); imageURL.searchParams.set('width','600'); image.src = imageURL.href; image.width = 600; image.height = 600; image.loading = 'lazy'; image.alt = p.name; imageLink.append(image);
    const copy = node('div','tm-card-copy'); copy.append(node('small','',p.region));
    const heading = node('h3'); const link = node('a','',p.name); link.href = urlFor(p); heading.append(link);
    copy.append(heading,node('span','',p.available ? `${text.from} ${money.format(p.price)}` : text.unavailable)); article.append(imageLink,copy); return article;
  }
  function filtered() {
    const query = normalize(search.value);
    return products.filter(p => (!area.value || p.region === area.value) && (!query || p.search.includes(query))).sort(sort.value === 'price' ? (a,b) => a.price-b.price || collator.compare(a.name,b.name) : sort.value === 'reverse' ? (a,b) => collator.compare(b.name,a.name) : (a,b) => collator.compare(a.name,b.name));
  }
  function render() {
    if (!ready) return;
    const rows = filtered();
    $('#tm-grid').replaceChildren(...rows.slice(0,visible).map(row));
    $('#tm-empty').hidden = rows.length > 0;
    $('#tm-count').textContent = rows.length === 1 ? text.resultOne : text.results.replace('{n}',rows.length.toLocaleString(page.dataset.locale));
    $('[data-more-wrap]').hidden = rows.length === 0;
    $('#tm-more').hidden = visible >= rows.length;
    $('#tm-shown').textContent = text.shown.replace('{n}',Math.min(visible,rows.length)).replace('{total}',rows.length);
    $('[data-random]').disabled = rows.length === 0;
  }
  function filtersChanged() { visible = 24; render(); }
  function reset() { search.value = ''; area.value = ''; sort.value = 'name'; filtersChanged(); }
  async function load() {
    if (loading) return;
    loading = true; $('#tm-error').hidden = true; $('#tm-count').textContent = text.loading;
    try {
      const seen = new Map();
      for (let number=1; number<=40; number++) {
        const response = await fetch(`${root}/collections/${encodeURIComponent(config.collection)}/products.json?limit=250&page=${number}`, {credentials:'same-origin'});
        if (!response.ok) throw new Error('Catalogue HTTP error');
        const data = await response.json();
        if (!Array.isArray(data.products)) throw new Error('Invalid catalogue');
        data.products.forEach(p => { if (p.tags?.includes('Municipalities 15km')) seen.set(String(p.id),p); });
        if (data.products.length < 250) break;
        if (number === 40) throw new Error('Catalogue pagination limit');
      }
      if (!seen.size || seen.size < Number(config.expectedCount || 0)) throw new Error('Incomplete catalogue');
      products = Array.from(seen.values()).map(p => {
        const title = p.title.split('. ')[0];
        const name = p.tags.find(tag => normalize(tag) === normalize(title)) || title;
        const region = regionOf(p); const variants = p.variants || [];
        const prices = variants.map(v=>Number(v.price)).filter(Number.isFinite);
        return {handle:p.handle,name,region,price:Math.min(...prices),available:variants.some(v=>v.available),image:p.images?.[0]?.src || '',search:normalize(`${name} ${region}`)};
      });
      const selected = area.value;
      const options = Array.from(new Set(products.map(p=>p.region).filter(Boolean))).sort(collator.compare);
      area.replaceChildren(new Option(text.allAreas,''),...options.map(name=>new Option(name,name)));
      area.value = selected; ready = true; render();
    } catch(error) {
      $('#tm-error').hidden = false; $('#tm-count').textContent = '';
    } finally { loading = false; }
  }
  $('[data-tools]').hidden = false; $('[data-controls]').hidden = false;
  search.addEventListener('input',filtersChanged); area.addEventListener('change',filtersChanged); sort.addEventListener('change',filtersChanged);
  page.querySelectorAll('[data-reset]').forEach(button=>button.addEventListener('click',reset));
  $('[data-retry]').addEventListener('click',load);
  $('#tm-more').addEventListener('click',()=>{visible+=24;render();});
  $('[data-random]').addEventListener('click',()=>{const rows=filtered();if (!rows.length)return;search.value=rows[Math.floor(Math.random()*rows.length)].name;filtersChanged();});
  page.querySelectorAll('[data-find]').forEach(link=>link.addEventListener('click',()=>{search.focus({preventScroll:true});}));
  load();
})();
